#import "../fragments/account-for-core-entity-fragment.graphql"

mutation CreateAccountForCoreEntity($input: AccountCreateInput!) {
    accountCreate(input: $input) {
        account {
            ...AccountForCoreEntityFragment
        }
    }
}
